import { render, staticRenderFns } from "./QryGroupMemberDialog.vue?vue&type=template&id=12cf2136&scoped=true&"
import script from "./QryGroupMemberDialog.vue?vue&type=script&lang=js&"
export * from "./QryGroupMemberDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cf2136",
  null
  
)

export default component.exports